var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grapesjs"},[_c('vue-grapesjs-component',[_c('h1',[_vm._v("Hello")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }